import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const KakaoLoginCallback = () => {
    const { loginWithToken } = useAuth();
    const navigate = useNavigate();
    const hasCalled = useRef(false);

    useEffect(() => {
        if (hasCalled.current) return;
        hasCalled.current = true;

        const search = window.location.search.substring(1);
        const params = new URLSearchParams(search);
        const token = params.get('code');

        if (token) {
            const inviteCode = sessionStorage.getItem('inviteCode');
            loginWithToken('kakao', token, inviteCode);
        } else {
            // No token, maybe user cancelled.
            alert('카카오 로그인을 취소했습니다.');
            navigate('/login', { replace: true });
        }
    }, [loginWithToken, navigate]);

    return <div>카카오 로그인 처리 중...</div>;
};

export default KakaoLoginCallback;
